'use strict';

var log = require('../../log/Log').channel('OfflinePopupService');
var sutl = require('../../sutl/Sutl');
var defaults = require('../../defaults/Defaults');

angular.module('inara').factory('OfflinePopupService', OfflinePopupService);

OfflinePopupService.$inject = ['$rootScope', 'KayleeService', 'EquipmentService',
                               '$ionicModal', '$q', '$timeout', 'RoomService',
                               '$templateCache', '$templateRequest'];

function OfflinePopupService($rootScope, KayleeService, EquipmentService,
                             $ionicModal, $q, $timeout, RoomService,
                             $templateCache, $templateRequest) {
    var hasInitialized = false;
    var offlineDlg = null;
    var dlgScope = $rootScope.$new(true);
    var isNetworkConnected = true;
    var isControllerPaired = true;
    var isControllerConnected = true;
    var isUiPreviewActive = false;
    var oldIsControllerPaired = isControllerPaired;
    var oldIsControllerConnected = isControllerConnected;
    var room = null;
    var nextDialogVisible = false;
    var dialogVisibleTimeout = null;
    var isUiPreview = false;
    var isUiPreviewExpired = false;

    // Cache the offline popup, since we won't be able to get it if we 
    // go offline.
    var offlinePopupTpl = 'offlinePopup.html';
    if (!angular.isDefined($templateCache.get(offlinePopupTpl))) {
        $templateRequest(offlinePopupTpl);              
    }

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
        if (toState.name !== 'start') return;

        if (angular.isDefined(toParams.preview) &&
            toParams !== null) {
            if (toParams.preview.toLowerCase() === 'true') {
              isUiPreview = true;
            }
            else {
              isUiPreview = false;
            }
        }
    });

    RoomService.onStateChanged(onRoomServiceStateChanged);

    dlgScope.inaraName = defaults.inara.name;
    dlgScope.portalName = defaults.mal.name;
    dlgScope.isUiPreviewExpired = function() {
        return !EquipmentService.isRunningUiPreview();
    };

    log.info('initializing');

    return {};

    function create() {
        if (hasInitialized) {
            log.warning('must call destroy() before calling create() again');
            return;
        }

        hasInitialized = true;
        room = RoomService.getRoom();
        KayleeService.onConnectionStateChanged(onConnectionStateChanged);
        RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
        if (room !== null) {
            var controllers = room.$getControllers();
            controllers.$onChildAdded(onControllerChildChanged);
            controllers.$onChildRemoved(onControllerChildChanged);
            controllers.$onChildChanged(onControllerChildChanged);
            room.$onChange(onRoomChanged);
        }
        else {
            log.warning('create(): room was null - no controller or room state will be reported!');
        }
    }

    function destroy() {
        if (!hasInitialized) return;

        KayleeService.offConnectionStateChanged(onConnectionStateChanged);
        RoomService.offOnlineChanged(onRoomServiceOnlineChanged);
        if (room !== null) {
            var controllers = room.$getControllers();
            controllers.$offChildAdded(onControllerChildChanged);
            controllers.$offChildRemoved(onControllerChildChanged);
            controllers.$offChildChanged(onControllerChildChanged);
            room.$offChange(onRoomChanged);
        }
        if (dialogVisibleTimeout !== null) {
            $timeout.cancel(dialogVisibleTimeout);
            dialogVisibleTimeout = null;
        }
        nextDialogVisible = false;
        hideDialog(); // will set offlineDlg = null, if needed
        isControllerPaired = true;
        isControllerConnected = true;
        // We don't reset isUiPreview when destroying, because it should only
        // be initialized by the 'start' state change (i.e. when the page is
        // reloaded.)
        isUiPreviewExpired = false;
        room = null;
        hasInitialized = false;
    }

    function onRoomServiceStateChanged(state) {
        // These states are all the places where resetRoomData() was being
        // called in RoomService (from where destroy() was originally being
        // called in OfflinePopupService) when it was an internal dependency
        // of RoomService.)
        // TODO: it may be possible to reduce the set of cases where destroy
        // needs to be called.
        if (state === 'handleUnauth' ||
            state === 'handleAuth' ||
            state === 'waitForKayleeEnabled' ||
            state === 'waitForKayleeVersion' ||
            state === 'handleControllerUnpaired' ||
            state === 'roomLoaded') {
            destroy();
        }
        if (state === 'roomLoaded') {
            create();
        }
    }

    function onControllerChildChanged(controllerKey) {
        updateControllerState();
    }

    function onRoomChanged(room) {
        var newIsUiPreviewActive = sutl.getNode(room, 'uiPreview.controllerId') !== null;

        if (newIsUiPreviewActive !== isUiPreviewActive) {
            isUiPreviewActive = newIsUiPreviewActive;
            updateDialogState();
        }

        updateUiPreviewState();
    }

    function onRoomServiceOnlineChanged(online) {
        if (online) {
            updateUiPreviewState();
        }
    }

    function updateUiPreviewState() {
        if (isUiPreview) {
            var newExpired = dlgScope.isUiPreviewExpired();
            if (newExpired !== isUiPreviewExpired) {
                isUiPreviewExpired = newExpired;
                updateDialogState();
            }
        }        
    }

    function updateControllerState(preventDialogUpdate) {
        return room.$getControllers().$loaded().then(function(controllers) {
            var connected = false;
            isControllerPaired = controllers.length !== 0;
            for (var i = 0; i < controllers.length; i++) {
                if (controllers[i].dbConnected) {
                    connected = true;
                    break; 
                }
            }
            isControllerConnected = connected;
            // log.debug('isControllerPaired = ' + isControllerPaired + 
            //           ', isControllerConnected = ' + isControllerConnected);

            if (!preventDialogUpdate &&
                (oldIsControllerPaired !== isControllerPaired ||
                oldIsControllerConnected !== isControllerConnected)) {
                updateDialogState();
            }

            oldIsControllerPaired = isControllerPaired;
            oldIsControllerConnected = isControllerConnected;
        }).catch(function(error) {
            // Controllers could not be loaded for room, which could be due
            // the the user not having permissions for the room. No need to 
            // update state.
            log.debug(error);
        });
    }

    function onConnectionStateChanged(connected) {
        isNetworkConnected = connected;
        //log.debug('connection state = ' + (connected ? 'online' : 'offline'));

        updateControllerState(true).then(function() {
            updateDialogState();
        });
    }

    function updateDialogState() {
        nextDialogVisible = !isNetworkConnected ||
                            !isControllerPaired && !isUiPreview && !isUiPreviewActive ||
                            isControllerPaired && isUiPreview ||
                            !isControllerPaired && isUiPreview && isUiPreviewExpired ||
                            !isControllerConnected && !isUiPreview && !isUiPreviewActive;

        //log.debug('nextDialogVisible: ' + nextDialogVisible);

        if (dialogVisibleTimeout !== null) {
            $timeout.cancel(dialogVisibleTimeout);
        }
        dialogVisibleTimeout = $timeout(processDialogHideShow, 500);
    }

    function processDialogHideShow() {
        dialogVisibleTimeout = null;

        hideDialog()
            .catch(function() {
                // canceled
            })
            .finally(function() {
                if (nextDialogVisible) {
                    showDialog();                        
                }
            });
    }

    function showDialog() {
        dlgScope.isNetworkConnected = isNetworkConnected;
        dlgScope.isControllerPaired = isControllerPaired;
        dlgScope.isControllerConnected = isControllerConnected;
        dlgScope.isUiPreview = isUiPreview;
        dlgScope.isUiPreviewActive = isUiPreviewActive;
        if (offlineDlg === null) {
            log.debug('offline dialog showing: isNetworkConnected = ' + 
                      isNetworkConnected +
                      ', isControllerPaired = ' + isControllerPaired + 
                      ', isControllerConnected = ' + isControllerConnected +
                      ', isUiPreview = ' + isUiPreview +
                      ', isUiPreviewExpired = ' + isUiPreviewExpired +
                      ', isUiPreviewActive = ' + isUiPreviewActive);
            return $ionicModal.fromTemplateUrl(
                'offlinePopup.html', 
                { 
                    backdropClickToClose: false,
                    hardwareBackButtonClose: false,
                    scope: dlgScope
                }).then(function(dlg) {
                    offlineDlg = dlg;
                    return offlineDlg.show();
                }).catch(function() {
                    log.error('error creating offline dialog');
                });            
        }
        else {
            return $q.resolve();
        }
    }

    function hideDialog() {
        if (offlineDlg !== null) {
            log.debug('offline dialog hiding');
            return offlineDlg.remove()
                .catch(function() {
                    log.error('error removing offline dialog');
                }).finally(function() {
                    offlineDlg = null;
                });
        }
        return $q.resolve();
    }
}

module.exports = OfflinePopupService;
